export const SET_2FA_DATA = '@AUTH/SET_2FA_DATA';
export const SET_PASSWORD_LOGIN_DATA = '@AUTH/SET_PASSWORD_LOGIN_DATA';
export const SET_AUTHDATA = '@auth/SET_AUTHDATA';
export const SET_USER = '@auth/SET_USER';
export const SET_ACCOUNT_GROUPS = '@auth/SET_ACCOUNT_GROUPS';
export const SET_ACCOUNT = '@auth/SET_ACCOUNT';
export const SET_ACCOUNTS = '@auth/SET_ACCOUNTS';
export const LOGOUT = '@auth/LOGOUT';
export const SET_MESSAGES = '@global/SET_MESSAGES';
export const SET_PAYMENT_METHODS = '@payments/SET_PAYMENT_METHODS';
export const SET_CURRENT_CUSTOMER = '@payments/SET_CURRENT_CUSTOMER';
export const SET_JOBS_SENSITIVE_FILTERS = '@jobs/SET_JOBS_SENSITIVE_FILTERS';
export const SET_IAP_AUTH_REQUIRED = '@iap/SET_IAP_AUTH_REQUIRED';
export const CLEAR_IAP_AUTH_REQUIRED = '@iap/CLEAR_IAP_AUTH_REQUIRED';
const JOBS_SENSITIVE_FILTERS_KEY = 'jobsSensitiveFilters';
export const setMessages = (messages) => {
    if (!Array.isArray(messages)) {
        messages = [messages];
    }
    return {
        type: SET_MESSAGES,
        payload: messages
    };
};
export const setIapAuthRequired = ({ details = null, unreadable = false } = {}) => ({
    type: SET_IAP_AUTH_REQUIRED,
    payload: { details, unreadable }
});
export const clearIapAuthRequired = () => ({
    type: CLEAR_IAP_AUTH_REQUIRED
});
export const setAuthData = (data) => {
    // the `finalize` endpoint loops back the original auth header valud
    let newAccessToken = '';
    if (data.accessToken) {
        const accessToken = data.accessToken.replace('Bearer ', '');
        newAccessToken = accessToken;
    }
    localStorage.setItem('accessToken', newAccessToken);
    return {
        type: SET_AUTHDATA,
        payload: {
            user: data.user,
            account: data.account,
            accessToken: newAccessToken,
            resToken: data.resToken
        }
    };
};
export const setUser = (user) => {
    return {
        type: SET_USER,
        payload: {
            user
        }
    };
};
export const setAccountGroups = (accountGroups) => {
    return {
        type: SET_ACCOUNT_GROUPS,
        payload: {
            accountGroups
        }
    };
};
export const setAccounts = (accounts) => {
    return {
        type: SET_ACCOUNTS,
        payload: {
            accounts
        }
    };
};
export const setAccount = (account) => {
    return {
        type: SET_ACCOUNT,
        payload: {
            account
        }
    };
};
// Job-search PII (email/name/phone) is kept out of the URL, so it persists in
// localStorage instead — read on store init, written whenever the filter changes.
export const readJobsSensitiveFilters = () => {
    try {
        const raw = localStorage.getItem(JOBS_SENSITIVE_FILTERS_KEY);
        return raw ? JSON.parse(raw) : {};
    }
    catch {
        return {};
    }
};
export const setJobsSensitiveFilters = (jobsSensitiveFilters) => {
    try {
        if (Object.keys(jobsSensitiveFilters).length > 0) {
            localStorage.setItem(JOBS_SENSITIVE_FILTERS_KEY, JSON.stringify(jobsSensitiveFilters));
        }
        else {
            localStorage.removeItem(JOBS_SENSITIVE_FILTERS_KEY);
        }
    }
    catch {
        // localStorage unavailable — filters just won't persist across reloads.
    }
    return {
        type: SET_JOBS_SENSITIVE_FILTERS,
        payload: { jobsSensitiveFilters }
    };
};
export const logout = () => {
    localStorage.removeItem('authData');
    localStorage.removeItem('accessToken');
    localStorage.removeItem(JOBS_SENSITIVE_FILTERS_KEY);
    return {
        type: LOGOUT,
        payload: {
            user: null,
            // TODO: Make this nullable!
            account: null,
            accessToken: ''
        }
    };
};
export const set2FAData = (data) => ({
    type: SET_2FA_DATA,
    payload: {
        otpToken: data.otpToken,
        otpImage: data.otpImage,
        resToken: data.resToken
    }
});
export const setPasswordLoginData = (data) => ({
    type: SET_PASSWORD_LOGIN_DATA,
    payload: {
        email: data.email,
        ssoBackup: data.ssoBackup
    }
});
export const setPaymentMethods = (data) => ({
    type: SET_PAYMENT_METHODS,
    payload: {
        paymentMethods: data
    }
});
export const setCurrentCustomer = (currentCustomer) => ({
    type: SET_CURRENT_CUSTOMER,
    payload: {
        currentCustomer
    }
});
